import React, { useContext } from 'react'
import Map from 'components/Map'
import { Button, Col, Row } from 'antd'
import { QuestionCircleFilled } from '@ant-design/icons'
import './Widgets.css'
import { useLayoutHeader } from 'components/MainLayout'
import AimOutlined from "@ant-design/icons/es/icons/AimOutlined";
import startRideIcon from "./img/start-ride.png"
import headerLogo from "components/MainLayout/img/RoroLogoGreenTransparent150.png";
import { GeolocationContext } from 'components/GeolocationContext'
import { useAutoToggle } from 'utils'


function MyLocationButton({ onFindUser }) {
    const { getLocation } = useContext(GeolocationContext)
    return (
        <Button className='button-zoom' type="primary" icon={<AimOutlined />}
            onClick={() => { getLocation(); onFindUser() }} />
    )
}

const headerConfig = {
    pageTitle: "RoRo",
    closeable: false,
    menuEnabled: true,
    backgroundColor: '',
    customClass: 'fixed-header transparent',
    extra: [<img
        src={headerLogo}
        width="50%"
    />]
}

const Home = ({ onScan, onGuide }) => {
    useLayoutHeader(headerConfig)
    const defaultPos = [35.7115, 51.4074]
    const zoomLevel = 16

    const [followUser, showUserOnMap] = useAutoToggle(true)

    return <React.Fragment>
        <Map
            position={defaultPos}
            zoomLevel={zoomLevel}
            followUser={followUser}
        />
        <div className="fixed-widgets p-1">
            <Row justify="space-between">
                <Col>
                    <Row className='layout-action'>
                        <Col span={24}>
                            <MyLocationButton onFindUser={showUserOnMap} />
                        </Col>
                        <Col span={24}>
                            <Button className='button-zoom' type="primary" icon={<QuestionCircleFilled />}
                                onClick={onGuide} />
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row justify="center">
                <Button type="primary" className='start-ride-btn' size='large' onClick={onScan}>
                    <img src={startRideIcon} alt="" />
                    شروع سفر
                </Button>
            </Row>
        </div>

    </React.Fragment>
}

export default Home
